import React from 'react';
import {CircularProgressbar} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';

function ProgressLoading({progress}) {
    return (
        <>
            {
                progress > 0 &&
                <div id="blurry-cont" className="progress-cont">
                    <CircularProgressbar value={progress} text={`${progress}%`}/>
                </div>
            }
        </>
    );
}

export default ProgressLoading;